import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/random-team-stacking/actions';

class StackTeamsChecking extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.set('StackTeamsIsChecked', isChecked));
    }

    render() {
        const {stacking} = this.props;

        const isChecked = stacking.isAllActiveStackTeamsChecked();

        return (
            <label>
                <input
                    value="1"
                    type="checkbox"
                    onChange={(e) => ::this.onChange(e.target.checked)}
                    checked={isChecked}
                    className="form-control"
                />
                All teams
            </label>
        );
    }
}

function mapStatesToProps(state) {
    const {randomTeamStacking} = state;
    return {
        stacking: randomTeamStacking,
    };
}

export default connect(mapStatesToProps)(StackTeamsChecking);
